import { Badge, Card, Table } from "antd";
import React from "react";
import BannerCard from "../../../common/components/BannerCard";
import useEmployees from "./useEmployees";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

const EmployeeTaxes = ({ ...props }) => {
  const { newTaxLayout } = props;
  const { selectedEmployee } = useSelector((state: RootState) => state.global);
  const { taxColumns, isLoading, newLayoutTaxColumns, } = useEmployees();
  console.log(props);

  return (
    <Badge.Ribbon placement="start" text={"Tax Information"}>
      <Card className={"erp-banner-card-internal erp-auth-card"} style={{ backgroundColor: "#f5f6f7" }} bodyStyle={{ padding: "0", paddingTop:"24px" }}>
        {props.children}
      {newTaxLayout ? (<div><Table loading={isLoading} dataSource={selectedEmployee?.taxes?.filter((o) => o.taxLocality.toUpperCase() === "FEDERAL")} columns={newLayoutTaxColumns} scroll={{ x: 480 }} pagination={false} />
        <br />
        <Table loading={isLoading} size="small" dataSource={selectedEmployee?.taxes?.filter((o) => o.taxLocality.toUpperCase() != "FEDERAL")} columns={taxColumns} scroll={{ x: 480 }} /></div>) :
        (<Table loading={isLoading} size="small" dataSource={selectedEmployee?.taxes} columns={taxColumns} scroll={{ x: 480 }} />)
      }
      </Card>
    </Badge.Ribbon>
  );
};

export default EmployeeTaxes;
